// extracted by mini-css-extract-plugin
module.exports = {"background":"ScrollTip-module--background--2Cc3-","text":"ScrollTip-module--text--1lFQa"};